<template>
  <div class="g-page">
    <!-- HEADER -->
    <div class="header-row">
      <div class="title-block">
        <button class="btn-back" @click="$router.push('/paket/index')">
          <b-icon icon="arrow-left-short" font-scale="1.4"></b-icon>
        </button>
        <h2 class="page-title">{{ isEdit ? 'Paketni tahrirlash' : 'Yangi paket' }}</h2>
      </div>
      <div class="action-buttons">
        <button class="btn-cancel" @click="$router.push('/paket/index')">BEKOR</button>
        <button class="btn-save" @click="submitForm" :disabled="loading">
          <b-spinner small v-if="loading" class="mr-1"></b-spinner>
          {{ isEdit ? 'SAQLASH' : 'QO\'SHISH' }}
        </button>
      </div>
    </div>

    <div class="main-card">
      <!-- ASOSIY MA'LUMOTLAR -->
      <div class="form-section">
        <div class="form-row">
          <div class="form-group fg-2">
            <label>Paket nomi <span class="text-danger">*</span></label>
            <input type="text" v-model="form.name" class="custom-input" placeholder="Masalan: Gentra Full Paket">
          </div>
          <div class="form-group">
            <label>Avtomobil Modeli</label>
            <select @change="onModelChange" v-model="form.model_id" class="custom-input">
              <option :value="null">Barchasi</option>
              <option v-for="m in carModels" :key="m.id" :value="m.id">{{ m.name }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>Paket Turi</label>
            <div class="select-with-actions">
              <select v-model="form.package_type_id" class="custom-input select-flex">
                <option :value="null" disabled>Tanlang</option>
                <option v-for="t in packageTypes" :key="t.id" :value="t.id">{{ t.name }}</option>
              </select>
              <button type="button" class="sa-btn add" @click="openTypeModal('add')" title="Qo'shish">
                <b-icon icon="plus"></b-icon>
              </button>
              <button type="button" class="sa-btn edit" @click="openTypeModal('edit')" :disabled="!form.package_type_id">
                <b-icon icon="pencil"></b-icon>
              </button>
              <button type="button" class="sa-btn del" @click="confirmDeleteType" :disabled="!form.package_type_id">
                <b-icon icon="trash"></b-icon>
              </button>
            </div>
          </div>
        </div>

        <!-- Narxlar: chakana va optom yonma-yon -->
        <div class="price-grid">
          <div class="price-group">
            <div class="price-label">Ish haqi</div>
            <div class="price-pair">
              <div class="price-input-wrap">
                <span class="price-tag ch">Ch</span>
                <input type="number" v-model.number="form.labor_price_chakana" class="custom-input" placeholder="0">
              </div>
              <div class="price-input-wrap">
                <span class="price-tag op">Op</span>
                <input type="number" v-model.number="form.labor_price_optom" class="custom-input" placeholder="0">
              </div>
            </div>
          </div>
          <div class="price-group">
            <div class="price-label">Peredelka</div>
            <div class="price-pair">
              <div class="price-input-wrap">
                <span class="price-tag ch">Ch</span>
                <input type="number" v-model.number="form.redo_price_chakana" class="custom-input" placeholder="0">
              </div>
              <div class="price-input-wrap">
                <span class="price-tag op">Op</span>
                <input type="number" v-model.number="form.redo_price_optom" class="custom-input" placeholder="0">
              </div>
            </div>
          </div>
          <div class="price-group">
            <div class="price-label">Rasm</div>
            <div class="image-compact">
              <div class="image-preview-sm" v-if="imagePreview || form.image">
                <img :src="imagePreview || serverImage" alt="">
                <button type="button" class="img-rm" @click="removeImage"><b-icon icon="x-lg"></b-icon></button>
              </div>
              <button v-else type="button" class="img-upload-btn" @click="$refs.imageInput.click()">
                <b-icon icon="cloud-arrow-up"></b-icon> Yuklash
              </button>
              <input type="file" ref="imageInput" accept="image/png,image/jpeg,image/jpg,image/webp"
                @change="onFileSelect" style="display:none">
            </div>
          </div>
        </div>
      </div>

      <!-- MAHSULOTLAR JADVALI -->
      <div class="form-section table-area">
        <div class="section-header-row">
          <h5 class="section-title">Paket tarkibi</h5>
          <div class="table-controls">
            <button class="btn-add-row" @click="addNewRow">
              <b-icon icon="plus-circle" class="mr-1"></b-icon> Qo'shish
            </button>
          </div>
        </div>

        <div class="table-container">
          <table class="item-table">
            <thead>
              <tr>
                <th style="width:40px">№</th>
                <th style="width:280px">Mahsulot</th>
                <th style="width:120px">Narx (ch)</th>
                <th style="width:120px">Narx (op)</th>
                <th style="width:70px">Soni</th>
                <th style="width:110px">Jami (ch)</th>
                <th style="width:110px">Jami (op)</th>
                <th style="width:40px"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in form.items" :key="index">
                <td class="text-center">{{ index + 1 }}</td>
                <td>
                  <v-select
                    class="table-vselect"
                    :value="item.product_id"
                    :options="inventory"
                    :reduce="p => p.id"
                    :get-option-label="p => p.extra_name || p.name"
                    :filter="filterProducts"
                    append-to-body
                    placeholder="Mahsulot qidiring..."
                    @input="val => onProductSelect(index, val)"
                  >
                    <template #no-options>Topilmadi</template>
                    <template #option="p">
                      <div>{{ p.extra_name || p.name }}</div>
                      <small class="text-muted">{{ p.balance }} dona</small>
                    </template>
                  </v-select>
                </td>
                <td><input type="number" v-model.number="item.price_chakana" class="table-input" min="0"></td>
                <td><input type="number" v-model.number="item.price_optom" class="table-input" min="0"></td>
                <td><input type="number" v-model.number="item.quantity" class="table-input text-center" min="1"></td>
                <td class="total-cell">{{ formatMoney(item.price_chakana * item.quantity) }}</td>
                <td class="total-cell">{{ formatMoney(item.price_optom * item.quantity) }}</td>
                <td class="text-center">
                  <button class="btn-del-row" @click="removeRow(index)">
                    <b-icon icon="x-lg" font-scale="0.7"></b-icon>
                  </button>
                </td>
              </tr>
              <tr v-if="form.items.length === 0">
                <td colspan="8" class="text-center text-muted py-3">Mahsulot qo'shilmagan</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- JAMI -->
        <div class="totals-bar">
          <div class="total-group">
            <span class="tl">Chakana:</span>
            <span class="tv">mat {{ formatShort(totalMaterialChakana) }}</span>
            <span class="tv blue-text">ish {{ formatShort(form.labor_price_chakana) }}</span>
            <span class="tv orange-text">pred {{ formatShort(form.redo_price_chakana) }}</span>
            <span class="total-badge ch">{{ formatMoney(grandTotalChakana) }}</span>
          </div>
          <div class="total-group">
            <span class="tl">Optom:</span>
            <span class="tv">mat {{ formatShort(totalMaterialOptom) }}</span>
            <span class="tv blue-text">ish {{ formatShort(form.labor_price_optom) }}</span>
            <span class="tv orange-text">pred {{ formatShort(form.redo_price_optom) }}</span>
            <span class="total-badge op">{{ formatMoney(grandTotalOptom) }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- PAKET TURI MODAL -->
    <b-modal id="modal-type" :title="typeModal.isEdit ? 'Turni tahrirlash' : 'Yangi tur'" hide-footer centered size="sm" no-close-on-backdrop>
      <div>
        <label class="modal-label">Nomi <span class="text-danger">*</span></label>
        <input type="text" v-model="typeModal.name" class="custom-input" placeholder="Masalan: Premium" @keyup.enter="savePackageType">
        <div class="d-flex gap-2 mt-3">
          <button class="btn-cancel flex-fill" @click="$bvModal.hide('modal-type')">Bekor</button>
          <button class="btn-save flex-fill" @click="savePackageType" :disabled="!typeModal.name.trim()">
            {{ typeModal.isEdit ? 'Saqlash' : 'Qo\'shish' }}
          </button>
        </div>
      </div>
    </b-modal>

    <!-- O'CHIRISH MODALI -->
    <b-modal id="modal-delete-type" hide-footer centered size="sm" no-close-on-backdrop>
      <div class="text-center p-2">
        <div class="warning-icon mb-2">!</div>
        <h5 class="fw-bold mb-2">Turni o'chirishni tasdiqlaysizmi?</h5>
        <div class="d-flex gap-2">
          <button class="btn-cancel flex-fill" @click="$bvModal.hide('modal-delete-type')">YO'Q</button>
          <button class="btn-save flex-fill" style="background:#ef4444" @click="deletePackageType">HA</button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      loading: false,
      isEdit: false,
      carModels: [],
      packageTypes: [],
      inventory: [],
      imageFile: null,
      imagePreview: null,
      form: {
        name: "",
        model_id: null,
        package_type_id: null,
        labor_price_chakana: 0,
        redo_price_chakana: 0,
        labor_price_optom: 0,
        redo_price_optom: 0,
        image: null,
        items: [{ product_id: null, price_chakana: 0, price_optom: 0, quantity: 1 }]
      },
      typeModal: { isEdit: false, id: null, name: "" }
    }
  },
  computed: {
    serverImage() {
      if (this.form.image) return axios.defaults.baseURL + '/api/v1/uploads/' + this.form.image;
      return null;
    },
    totalMaterialChakana() {
      return this.form.items.reduce((sum, item) => sum + (Number(item.price_chakana || 0) * Number(item.quantity || 0)), 0);
    },
    totalMaterialOptom() {
      return this.form.items.reduce((sum, item) => sum + (Number(item.price_optom || 0) * Number(item.quantity || 0)), 0);
    },
    grandTotalChakana() {
      return this.totalMaterialChakana + Number(this.form.labor_price_chakana || 0) + Number(this.form.redo_price_chakana || 0);
    },
    grandTotalOptom() {
      return this.totalMaterialOptom + Number(this.form.labor_price_optom || 0) + Number(this.form.redo_price_optom || 0);
    }
  },
  methods: {
    formatMoney(v) {
      if (!v) return "0";
      return Number(v).toLocaleString().replace(/,/g, ' ');
    },
    formatShort(v) {
      if (!v) return "0";
      return Number(v).toLocaleString().replace(/,/g, ' ');
    },
    onFileSelect(e) {
      const file = e.target.files[0];
      if (file) this.setImage(file);
    },
    setImage(file) {
      this.imageFile = file;
      this.imagePreview = URL.createObjectURL(file);
    },
    removeImage() {
      this.imageFile = null;
      this.imagePreview = null;
      this.form.image = null;
      if (this.$refs.imageInput) this.$refs.imageInput.value = '';
    },
    onModelChange() {
      // Mahsulotlar endi model bo'yicha filtrlanmaydi — barchasi ko'rsatiladi,
      // shuning uchun model o'zgarganda inventarni qayta yuklash shart emas.
    },
    updateProductPrice(index) {
      const selectedId = this.form.items[index].product_id;
      const product = this.inventory.find(p => p.id === selectedId);
      if (product && product.price_register) {
        this.form.items[index].price_chakana = Number(product.price_register.chakana_price || 0);
        this.form.items[index].price_optom = Number(product.price_register.optom_price || 0);
      }
    },
    onProductSelect(index, productId) {
      this.form.items[index].product_id = productId;
      this.updateProductPrice(index);
    },
    // Mahsulotni to'liq (extra_name) nomi bo'yicha, matnning istalgan joyida qidirish
    filterProducts(options, search) {
      const q = (search || '').toLowerCase().trim();
      if (!q) return options;
      return options.filter(p => (p.extra_name || p.name || '').toLowerCase().includes(q));
    },
    async loadInventory() {
      try {
        // model_id: null — barcha mahsulotlar (model bo'yicha filtrlamaymiz)
        const res = await axios.post('api/v1/product/all-price-balance/0', {
          sklad_id: 1, keyword: "", model_id: null, brand_id: null, flat: true, limit: 1000, page: 1
        });
        this.inventory = res.data;
      } catch (e) { console.error("Mahsulotlarni yuklashda xato:", e); }
    },
    async fetchPackageData() {
      try {
        const res = await axios.get(`/api/v1/repair_package/${this.$route.params.id}`);
        const packageData = res.data;
        await this.loadInventory();
        this.form = packageData;
        if (!this.form.items || this.form.items.length === 0) this.addNewRow();
      } catch (e) { console.error("Paket ma'lumotini yuklashda xato:", e); }
    },
    async fetchInitialData() {
      try {
        const [m, t] = await Promise.all([
          axios.get('/api/v1/model'),
          axios.get('/api/v1/package_types')
        ]);
        this.carModels = m.data;
        this.packageTypes = t.data;
      } catch (e) { console.error("Initial data error", e); }
    },
    addNewRow() {
      this.form.items.push({ product_id: null, price_chakana: 0, price_optom: 0, quantity: 1 });
    },
    removeRow(i) {
      this.form.items.splice(i, 1);
    },
    async submitForm() {
      if (!this.form.name) return alert("Paket nomini kiriting!");
      this.loading = true;
      try {
        const url = this.isEdit ? `/api/v1/repair_package/${this.$route.params.id}` : '/api/v1/repair_package';
        const method = this.isEdit ? 'put' : 'post';
        const formData = new FormData();
        formData.append('name', this.form.name);
        formData.append('model_id', this.form.model_id || 0);
        formData.append('package_type_id', this.form.package_type_id || 0);
        formData.append('labor_price_chakana', this.form.labor_price_chakana || 0);
        formData.append('redo_price_chakana', this.form.redo_price_chakana || 0);
        formData.append('labor_price_optom', this.form.labor_price_optom || 0);
        formData.append('redo_price_optom', this.form.redo_price_optom || 0);
        formData.append('total_amount', this.grandTotalChakana);
        formData.append('items', JSON.stringify(this.form.items));
        if (this.imageFile) {
          formData.append('image', this.imageFile);
        } else if (this.form.image) {
          formData.append('image', this.form.image);
        }
        await axios[method](url, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
        this.$router.push('/paket/index');
      } catch (e) { alert("Saqlashda xatolik!"); }
      finally { this.loading = false; }
    },
    openTypeModal(mode) {
      if (mode === 'edit') {
        const current = this.packageTypes.find(t => t.id === this.form.package_type_id);
        if (!current) return;
        this.typeModal = { isEdit: true, id: current.id, name: current.name };
      } else {
        this.typeModal = { isEdit: false, id: null, name: "" };
      }
      this.$bvModal.show('modal-type');
    },
    async savePackageType() {
      const name = this.typeModal.name.trim();
      if (!name) return;
      try {
        if (this.typeModal.isEdit) {
          await axios.put(`/api/v1/package_types/${this.typeModal.id}`, { name });
        } else {
          const res = await axios.post('/api/v1/package_types', { name });
          this.form.package_type_id = res.data.id;
        }
        const t = await axios.get('/api/v1/package_types');
        this.packageTypes = t.data;
        this.$bvModal.hide('modal-type');
      } catch (e) { alert("Paket turini saqlashda xatolik!"); }
    },
    confirmDeleteType() {
      if (!this.form.package_type_id) return;
      this.$bvModal.show('modal-delete-type');
    },
    async deletePackageType() {
      try {
        await axios.delete(`/api/v1/package_types/${this.form.package_type_id}`);
        this.form.package_type_id = null;
        const t = await axios.get('/api/v1/package_types');
        this.packageTypes = t.data;
        this.$bvModal.hide('modal-delete-type');
      } catch (e) { alert("Paket turini o'chirishda xatolik!"); }
    }
  },
  async mounted() {
    await this.fetchInitialData();
    if (this.$route.params.id) {
      this.isEdit = true;
      await this.fetchPackageData();
    } else {
      await this.loadInventory();
    }
  }
}
</script>

<style scoped>
.g-page {
  padding: 16px;
  background: #f0f2f5;
  min-height: 100vh;
}

/* Header */
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.title-block {
  display: flex;
  align-items: center;
  gap: 10px;
}
.page-title {
  font-weight: 800;
  color: #1e293b;
  font-size: 20px;
  margin: 0;
}
.btn-back {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.action-buttons {
  display: flex;
  gap: 8px;
}
.btn-cancel {
  background: #f1f5f9;
  color: #64748b;
  border: 1px solid #e2e8f0;
  padding: 8px 20px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
}
.btn-save {
  background: linear-gradient(135deg, #a142f4, #8b2cf5);
  color: white;
  border: none;
  padding: 8px 24px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
  box-shadow: 0 3px 10px rgba(161, 66, 244, 0.25);
}
.btn-save:disabled { opacity: 0.6; cursor: not-allowed; }

/* Card */
.main-card {
  background: white;
  border-radius: 14px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}
.form-section {
  padding: 16px 20px;
  border-bottom: 1px solid #f1f5f9;
}

/* Form row */
.form-row {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 14px;
}
.form-group {
  flex: 1;
  min-width: 180px;
}
.form-group.fg-2 {
  flex: 2;
  min-width: 280px;
}
.form-group label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  color: #64748b;
  margin-bottom: 4px;
  text-transform: uppercase;
}
.custom-input {
  width: 100%;
  height: 38px;
  background: #fff;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  padding: 0 10px;
  font-weight: 600;
  font-size: 13px;
  color: #1e293b;
}
.custom-input:focus {
  border-color: #a142f4;
  outline: none;
  box-shadow: 0 0 0 3px rgba(161, 66, 244, 0.08);
}

/* Select with actions */
.select-with-actions {
  display: flex;
  gap: 4px;
  align-items: center;
}
.select-flex { flex: 1; min-width: 0; }
.sa-btn {
  width: 30px;
  height: 30px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: white;
  font-size: 12px;
}
.sa-btn:disabled { opacity: 0.3; cursor: not-allowed; }
.sa-btn.add { color: #22c55e; }
.sa-btn.edit { color: #3b82f6; }
.sa-btn.del { color: #ef4444; }

/* Price grid: chakana/optom yonma-yon */
.price-grid {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  align-items: flex-end;
}
.price-group {
  flex: 1;
  min-width: 200px;
}
.price-label {
  font-size: 11px;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  margin-bottom: 4px;
}
.price-pair {
  display: flex;
  gap: 6px;
}
.price-input-wrap {
  flex: 1;
  position: relative;
}
.price-tag {
  position: absolute;
  left: 6px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 10px;
  font-weight: 800;
  padding: 1px 5px;
  border-radius: 4px;
  pointer-events: none;
}
.price-tag.ch { background: #dbeafe; color: #2563eb; }
.price-tag.op { background: #fef3c7; color: #d97706; }
.price-input-wrap .custom-input {
  padding-left: 34px;
}

/* Image compact */
.image-compact {
  display: flex;
  align-items: center;
  height: 38px;
}
.img-upload-btn {
  background: #f8fafc;
  border: 1.5px dashed #cbd5e1;
  border-radius: 8px;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 600;
  color: #94a3b8;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
}
.img-upload-btn:hover { border-color: #a142f4; color: #a142f4; }
.image-preview-sm {
  position: relative;
  height: 38px;
}
.image-preview-sm img {
  height: 38px;
  width: auto;
  border-radius: 6px;
  object-fit: cover;
  border: 1px solid #e2e8f0;
}
.img-rm {
  position: absolute;
  top: -4px;
  right: -4px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #ef4444;
  color: white;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 8px;
}

/* Table section */
.table-area { background: #f8fafc; }
.section-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  flex-wrap: wrap;
  gap: 8px;
}
.section-title {
  font-size: 14px;
  font-weight: 700;
  color: #475569;
  margin: 0;
}
.table-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}
.search-wrap {
  position: relative;
  display: flex;
  align-items: center;
}
.s-icon {
  position: absolute;
  left: 8px;
  color: #94a3b8;
  font-size: 12px;
}
.search-input {
  height: 32px;
  width: 180px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 0 8px 0 28px;
  font-size: 12px;
  outline: none;
}
.search-input:focus { border-color: #a142f4; }
.btn-add-row {
  background: white;
  border: 1.5px solid #a142f4;
  color: #a142f4;
  padding: 5px 12px;
  border-radius: 8px;
  font-weight: 700;
  font-size: 12px;
  cursor: pointer;
  white-space: nowrap;
}
.btn-add-row:hover { background: #a142f4; color: white; }

/* Table */
.table-container {
  background: white;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
}
.item-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}
.item-table th {
  background: #f1f5f9;
  padding: 8px 10px;
  font-size: 11px;
  font-weight: 700;
  color: #475569;
  text-transform: uppercase;
  border-bottom: 1.5px solid #e2e8f0;
}
.item-table td {
  padding: 6px 10px;
  border-bottom: 1px solid #f1f5f9;
  font-size: 13px;
}
.table-vselect {
  width: 100%;
}
.table-vselect ::v-deep .vs__dropdown-toggle {
  width: 100%;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  padding: 0 2px;
  min-height: 32px;
  background: white;
  box-sizing: border-box;
}
.table-vselect ::v-deep .vs__selected-options {
  flex-wrap: nowrap;
  min-width: 0;
  overflow: hidden;
}
.table-vselect ::v-deep .vs__search,
.table-vselect ::v-deep .vs__selected {
  font-weight: 600;
  font-size: 13px;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.table-input, .table-select {
  width: 100%;
  height: 32px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  padding: 0 6px;
  font-weight: 600;
  font-size: 13px;
}
.table-input:focus, .table-select:focus { border-color: #a142f4; outline: none; }
.total-cell {
  font-weight: 700;
  color: #1e293b;
  text-align: right;
  font-size: 13px;
}
.btn-del-row {
  background: #fee2e2;
  color: #ef4444;
  border: none;
  width: 26px;
  height: 26px;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-del-row:hover { background: #ef4444; color: white; }

/* Totals bar */
.totals-bar {
  margin-top: 12px;
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.total-group {
  flex: 1;
  min-width: 300px;
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 8px 12px;
  flex-wrap: wrap;
}
.tl {
  font-size: 12px;
  font-weight: 700;
  color: #64748b;
}
.tv {
  font-size: 12px;
  font-weight: 600;
  color: #94a3b8;
}
.blue-text { color: #2563eb; }
.orange-text { color: #ea580c; }
.total-badge {
  margin-left: auto;
  padding: 4px 12px;
  border-radius: 8px;
  font-weight: 800;
  font-size: 14px;
  color: white;
}
.total-badge.ch { background: linear-gradient(135deg, #a142f4, #8b2cf5); }
.total-badge.op { background: linear-gradient(135deg, #d97706, #b45309); }

/* Modal */
.modal-label {
  font-size: 12px;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  margin-bottom: 4px;
  display: block;
}
.warning-icon {
  width: 44px;
  height: 44px;
  background: #fee2e2;
  color: #ef4444;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
  margin: 0 auto;
}
</style>
